if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.changePriceButton();
      // this.cartNotification = document.querySelector('cart-notification');
      const priceSource = document.getElementById(`Quantity-${this.dataset.section}`);
      const priceDestination = document.getElementById(
          `Quantity-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      if (priceSource && priceDestination) {
        priceSource.innerHTML = priceDestination.innerHTML
        priceSource.dataset.price =  priceDestination.dataset.price
      }
    }

    changePriceButton() {
      const quantityInputs = document.querySelectorAll('.quantity__input');
      const priceElements = document.querySelectorAll('.product-form__submit-price');

      if (priceElements.length > 0 && quantityInputs.length > 0) {
        let unitPrice = priceElements[0]?.dataset.price;
        let money = priceElements[0]?.dataset.money;



        function updatePriceAndQuantity() {
          let quantity = parseInt(this.value);
          let newPrice = unitPrice * quantity;

          let currencySymbol = money.match(/[^\d.,]+/);

          priceElements.forEach(priceElement => {
            priceElement.innerHTML = newPrice + currencySymbol;
          });

          quantityInputs.forEach(input => {
            input.value = quantity;
          });
        }

        quantityInputs.forEach(quantityInput => {
          quantityInput.addEventListener('change', updatePriceAndQuantity);
          quantityInput.addEventListener('input', updatePriceAndQuantity);
        });
      }
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              return;
            }

            // this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
    }
  });
}